import  { useEffect, useRef, useState } from 'react'
import {  Slider, SliderChangeEvent, SliderHandle, SliderLabel } from '@progress/kendo-react-inputs'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_GetValueResponse } from '../../../api'
import { Label } from "@progress/kendo-react-labels";
import parse from 'html-react-parser'

interface SliderProps {
  id: number,
  question: string,
  minValue: number,
  maxValue: number,
  defaultValue: number,
  stepValue: number,
  isError: boolean,
  focus:boolean,
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const SliderCommand = (props: SliderProps) => {
  const [value, setValue] = useState(props.defaultValue);
  const labelId = `${props.id}_label`;
  const sliderRef = useRef<SliderHandle>();

  useEffect(() => {

    if(props.focus) {
      (sliderRef.current?.sliderTrack?.querySelector('.k-draghandle') as HTMLElement).focus();
    }

    let response: SurveyEngine_Models_GetValueResponse = {
      commandType: "SLIDER",
      commandIndex: props.id,
      value: String(Math.trunc(value))
    }
    props.callback(response);
  }, [props,value]);

  const handleSliderChange = (value: number) => {
    
    let response: SurveyEngine_Models_GetValueResponse = {
      commandType: "Remove",
      commandIndex: props.id,
      value: "-1"
    };
    let newValue: number = value??props.defaultValue;

    response = {
      commandType: "SLIDER",
      commandIndex: props.id,
      value: String(Math.trunc(newValue))
    }
    props.callback(response);
    setValue(newValue);
  }

  function generateSliderLabels(min: number, max: number, step: number) {
    const labels = [];

    // Generate normal stepped labels
    for (let value = min; value <= max; value += step) {
      labels.push(
        <SliderLabel key={value} position={value} onClick={() => handleSliderChange(value)}>
          {value}
        </SliderLabel>
      );
    }

    // Ensure max is included exactly once
    if (labels[labels.length - 1].key !== String(max)) {
      labels.push(
        <SliderLabel key={max} position={max} onClick={() => handleSliderChange(max)}>
          {max}
        </SliderLabel>
      );
    }

    return labels;
  }

  return (
    <div className="theme-slider">
      <Label className="theme-question py-10 text-xl font-semibold" id={labelId}>
        {parse(props.question.replace(/""/g,'"'))}
      </Label>
      <div className="theme-answer py-4 flex w-full">
        <div className="basis-11/12 pt-1 align-middle">
          <Slider
            ref={sliderRef}
            tabIndex={0} 
            ariaLabelledBy={labelId}
            step={props.stepValue}
            defaultValue={value}
            min={props.minValue}
            max={props.maxValue}
            className="!w-full theme-slider-color"
            value={value}
            onChange={(e) => handleSliderChange(e?.value)}
          >
            {generateSliderLabels(props.minValue, props.maxValue, props.stepValue)}
          </Slider>
        </div>
        <div className="basis-1/12 text-right px-2 align-middle text-xl font-semibold">
          {Math.trunc(value)}
        </div>
      </div>
    </div>
  )
}

